export var omitUndefined = function omitUndefined(obj) {
  var newObj = {};
  Object.keys(obj || {}).forEach(function (key) {
    if (obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });

  if (Object.keys(newObj).length < 1) {
    return undefined;
  }

  return newObj;
};